/**
 * fnv1a64
 *
 * FNV-1a 64-bit hash over a string's UTF-16 code units, computed with BigInt:
 * dependency-free, synchronous, and identical in browser and Node. It is the
 * shared fingerprint primitive behind both the ArTable formula stamp
 * (`computeArFormulaFingerprint`) and the Form Derive stamp.
 *
 * Its output is PERSISTED inside those stamps, so the algorithm is frozen:
 * changing the constants, the code-unit iteration, or the padding silently
 * invalidates every hash already stored and makes stale rows read as drifted.
 */

const FNV_OFFSET_BASIS = 0xcbf29ce484222325n;
const FNV_PRIME = 0x100000001b3n;
const UINT64_MASK = 0xffffffffffffffffn;

function fnv1a64(text: string): string {
  let hash = FNV_OFFSET_BASIS;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= BigInt(text.charCodeAt(i));
    hash = (hash * FNV_PRIME) & UINT64_MASK;
  }
  return hash.toString(16).padStart(16, '0');
}

export { fnv1a64 };
